<template>
  <div class="">
    <DevCards />
  </div>
</template>
<script>
import DevCards from "./components/DevCards.vue";
export default {
  components: { DevCards },
};
</script>
